<div class="modal-header">
  <h4 class="modal-title pull-left">{{'GLOBAL.ZONE' | translate}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="showModalCancel()" title="{{'GLOBAL.FERMER' | translate}}">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form id="myForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="nomZone">{{'GLOBAL.NOM' | translate}}</label>
      <input id="nomZone" type="text" [(ngModel)]="zone.nom" name="nomZone" class="form-control" placeholder="{{'GLOBAL.NOM' | translate}}" maxlength="256" />
      @if (nomInvalide) {
        <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
      }
    </div>
    @if (estModif) {
      <div class="form-group">
        <label for="selectIsActif">{{'GLOBAL.ACTIF' | translate}}</label>
        <button type="button" name="selectIsActif" btnCheckbox class="toggle-btn" [ngClass]="zone.isActif === true ? 'btn-success':'btn-danger'" [(ngModel)]="zone.isActif">
          {{zone.isActif ? ('GLOBAL.OUI' | translate) : ('GLOBAL.NON' | translate)}}
        </button>
      </div>
    }
    @if (erreurApi) {
      <div class="custom-alert custom-alert-sm">{{'GLOBAL.ERREUR_MAJ_API' | translate }}</div>
    }
    <div class="btn-toolbar justify-content-between">
      <div class="btn-group" role="group">
        <button type="submit" class="btn btn-outline-success">{{'GLOBAL.VALIDER' | translate}}</button>
      </div>
      <div class="btn-group" role="group">
        <button type="button" class="btn btn-secondary" (click)="showModalCancel()">{{'GLOBAL.FERMER' | translate}}</button>
      </div>
    </div>
  </form>
</div>

<div bsModal #modalConfirmCancel="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="custom-overlay"></div>
      <div class="modal-body text-center">
        <p>{{'GLOBAL.CONFIRMATION_ANNULATION' | translate}}</p>
        <button type="button" class="btn btn-primary" (click)="annulModif()">{{'GLOBAL.OUI' | translate}}</button>
        <button type="button" class="btn btn-secondary" (click)="modalConfirmCancel.hide()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
      </div>
    </div>
  </div>
</div>
